module.exports = {"themeColors":{"primary":"#0C99D9","secondary":"#1E4B60","highlight":"#50E3C2","white":"#fff","grey":"#4E5C68"}}


//////////////////
// WEBPACK FOOTER
// ./src/app-config.json
// module id = 6OFm
// module chunks = 1